import { render, staticRenderFns } from "./_base-button.vue?vue&type=template&id=71cec8e0&scoped=true"
import script from "./_base-button.vue?vue&type=script&lang=js"
export * from "./_base-button.vue?vue&type=script&lang=js"
import style0 from "./_base-button.vue?vue&type=style&index=0&id=71cec8e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cec8e0",
  null
  
)

export default component.exports